const MixLayoutContainer = ({ children }) => {
  return children;
};

export default MixLayoutContainer;
